import ProjectUsersFullCollection from "../../../../model2/project-user/collection-full"
import ProjectUserFull from "../../../../model2/project-user/project-user-full"
import UserAssignment from "../../model/user-assignment";
import Team from "../../../../model2/team/team";
import ProjectUserSession from "../../../../model2/project-user/project-user-session";

export default function ProjectTeamUser_checkDelete(projectUser: ProjectUserFull, userAssignment: UserAssignment, projectUsers: ProjectUsersFullCollection) {

    const projectOwner: ProjectUserSession | false = gd.session.projectUsers.filterByProject(projectUser.projectId).findProjectOwner();
    const user: ProjectUserSession = gd.session.projectUsers.get(`${projectUser.projectId}-${userAssignment.userId}`)!

    // Check if user is project owner
    if (projectOwner && projectOwner?.userId === userAssignment.userId) {
        return {
            canDelete: false,
            reasonCantDelete: "Project owner cannot be removed."
        }
    }

    // check not full access user (Organization/Settings/Full access)
    if (gd.ac.check.company.isFullAccess(userAssignment.userId)) {
        return {
            canDelete: false,
            reasonCantDelete: "Organization managers or administrators cannot be removed."
        }
    }

    const teams: Team[] = []

    // Check if user is in another team
    projectUsers.models.map((pu: ProjectUserFull)=> { // It's teams collection
        if (pu.team.userIds.includes(userAssignment.userId)) {
           teams.push(pu.team)
        }
    })

    if (teams.length > 1) {

        const teamsList = teams.map((team: Team)=> {
            return team.name
        }).join(", ")

        return {
            canDelete: false,
            reasonCantDelete: `You cannot remove "${user?.user.name}" because user is part of "${teamsList}" team(s).`
        }
    }

    if (!userAssignment.hasAssignments) {
        return {
            noAssignments: true,
            canDelete: true,
            message: "No assigned items found."
        }
    }

    return {canDelete: true}
}
